import { render, staticRenderFns } from "./AddTagForm.vue?vue&type=template&id=5c619492&scoped=true&"
import script from "./AddTagForm.vue?vue&type=script&lang=js&"
export * from "./AddTagForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c619492",
  null
  
)

export default component.exports